import * as _ from 'lodash';

export const getContactsDetails = (data) => {
  return data?.contactID ? [{
    contactID: _.get(data, 'contactID', null),
    firstName: _.get(data, 'contactFirstName', ''),
    lastName: _.get(data, 'contactLastName', ''),
    phone: _.get(data, 'contactPhone', ''),
    email: _.get(data, 'contactEmail', ''),
    deleted: _.get(data, 'contactDeleted', null),
  }] : [];
};